"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLendingMarket = exports.isLendingMarket = exports.LENDING_MARKET_SIZE = exports.LendingMarketLayout = void 0;
const buffer_layout_1 = require("buffer-layout");
const util_1 = require("../util");
/** @internal */
exports.LendingMarketLayout = (0, buffer_layout_1.struct)([
    (0, buffer_layout_1.u8)('version'),
    (0, buffer_layout_1.u8)('bumpSeed'),
    (0, util_1.publicKey)('owner'),
    (0, buffer_layout_1.blob)(32, 'quoteCurrency'),
    (0, util_1.publicKey)('tokenProgramId'),
    (0, util_1.publicKey)('oracleProgramId'),
    (0, buffer_layout_1.blob)(128, 'padding'),
    (0, util_1.publicKey)('switchboardOracleProgramId'),
], 'lendingMarket');
exports.LENDING_MARKET_SIZE = exports.LendingMarketLayout.span;
const isLendingMarket = (info) => {
    return info.data.length === exports.LENDING_MARKET_SIZE;
};
exports.isLendingMarket = isLendingMarket;
const parseLendingMarket = (pubkey, info) => {
    if (!(0, exports.isLendingMarket)(info))
        return;
    const buffer = Buffer.from(info.data);
    const lendingMarket = exports.LendingMarketLayout.decode(buffer);
    if (!lendingMarket.version)
        return;
    return {
        pubkey,
        info,
        data: lendingMarket,
    };
};
exports.parseLendingMarket = parseLendingMarket;
